// UI/Skeleton/pageSkeleton.jsx
const SkeletonBlock = ({ className = "" }) => <div className={`animate-pulse rounded-component bg-bg-subtle ${className}`} />

const PageSkeleton = () => (
	<section className="min-h-screen bg-bg-page px-6 py-24">
		<div className="max-w-5xl mx-auto flex flex-col gap-6">
			<SkeletonBlock className="h-6 w-32" />
			<SkeletonBlock className="h-12 w-2/3" />
			<SkeletonBlock className="h-5 w-full max-w-xl" />
			<SkeletonBlock className="h-5 w-5/6 max-w-xl" />
			<div className="flex gap-4 mt-2">
				<SkeletonBlock className="h-10 w-36" />
				<SkeletonBlock className="h-10 w-36" />
			</div>
		</div>
	</section>
)

export default PageSkeleton
